import MainLayout from "@/layout/MainLayout.vue"
import FeeComparisonView from "@/staff/FeeComparisonView.vue"
import ReportsView from "@/staff/ReportsView.vue"
import AssetsView from "@/staff/AssetsView.vue"
import SalesforceView from "@/staff/SalesforceView.vue"
import DevelopmentOpsView from "@/staff/DevelopmentOpsView.vue"
import OneCentralAccessView from "@/staff/OneCentralAccessView.vue"
import OneCentralImportView from "@/staff/OneCentralImportView.vue"
import MemberEventsView from "@/staff/MemberEventsView.vue"
import AuthenticationView from "@/staff/AuthenticationView.vue"
import ImportExportView from "@/staff/ImportExportView.vue"
import InsuranceCalculationView from "@/staff/InsuranceCalculationView.vue"
import DocumentView from "@/staff/DocumentView.vue"
import PcrTemplateView from "@/report/PcrTemplateView.vue"
import InsuranceStatementView from "@/staff/InsuranceStatementView.vue"

const defaultRoutes = [
  {
    path: "/staff",
    component: MainLayout,
    meta: {
      nav: true,
      title: "Staff",
    },
    children: [
      {
        path: "reporting",
        component: ReportsView,
      },
      {
        path: "micrositeDocuments",
        component: DocumentView,
      },
      {
        path: "feeComparison",
        component: FeeComparisonView,
      },
      {
        path: "insuranceCalculation",
        component: InsuranceCalculationView,
      },
      {
        path: "insuranceStatements",
        component: InsuranceStatementView,
      },
      {
        path: "memberEvents",
        component: MemberEventsView,
      },
    ],
  },
]

const adminRoutes = [
  {
    path: "/staff",
    component: MainLayout,
    meta: {
      nav: true,
      title: "Staff",
    },
    children: [
      {
        path: "reporting",
        component: ReportsView,
      },
      {
        path: "micrositeDocuments",
        component: DocumentView,
      },
      {
        path: "feeComparison",
        component: FeeComparisonView,
      },
      {
        path: "insuranceCalculation",
        component: InsuranceCalculationView,
      },
      {
        path: "insuranceStatements",
        component: InsuranceStatementView,
      },
      {
        path: "memberEvents",
        component: MemberEventsView,
      },
      {
        path: "pcrTemplates",
        component: PcrTemplateView,
      },
      {
        path: "investmentOptions",
        component: AssetsView,
      },
      {
        path: "importExport",
        component: ImportExportView,
      },
      {
        path: "salesforceExports",
        component: SalesforceView,
      },
      {
        path: "devOps",
        component: DevelopmentOpsView,
      },
      {
        path: "onecentralActivity",
        component: OneCentralAccessView,
      },
      {
        path: "onecentralImports",
        component: OneCentralImportView,
      },
      {
        path: "security",
        component: AuthenticationView,
      },
    ],
  },
]

export function getStaffRoutes(admin: boolean): Array<any> {
  return admin ? adminRoutes : defaultRoutes
}
